module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAALVBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMNHj8fz+PudxOH////n8PiFtdqRvN3U+kIUAAAACHRSTlMAYL//ACDP71kzCuAAAAC6SURBVHgB7dZBFYEBEAfxfwYSeBKwBwWWBJ4EJBBBi++giAw6eVPA7J05/wJMklV9bdOdvpR06xzvhg7nnEq7Zu1ol62jfdxU/QZ6TNCCMvRCKUI5QjlCOUI5QjlCOUI5QjlCOUI5QjlCOUI5QjlCOUI5QjlCOUIZQk3Q2xFGEcYQxhDGEMYQxhDGEMYQxhDGEMYQxhDGEMYQxhDGEMYQxhBGEEbRsxRJf1SjoRmt0WiyRrs2G79uX8gPN2YYXf7sGHoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/25b6.png
// module id = 1336
// module chunks = 0